export let goodsListLabels = [
  {
    label: '折扣',
    value: ''
  },
  {
    label: '活动价（元）',
    value: ''
  }
]
